<template>
  <v-card style="min-height: 100%">
    <v-card-title>
      <h2>Current week stats</h2>
    </v-card-title>
    <v-card-text>
      <v-flex>
        <v-row>
          <v-col cols="12" class="mt-4 text-center">
            <span class="text-center mx-auto headline mt-5" :class="currentActivityClass">{{ currentActivityLabel && currentActivityLabel.label }}</span>
            <br>
            <span class="text-center mx-auto mt-5">Engagement average</span>
          </v-col>
          <v-col cols="12" class="my-4 text-center">
            <h3 class="mt-4">
              You currently have
            </h3>
          </v-col>
          <v-col cols="6">
              <h3 class="text-center primary--text display-3" v-if="hasStaff">
                {{staffCount}}
              </h3>
              <btn-add-staff class="d-flex justify-center my-3" v-else></btn-add-staff>
              <span class="d-block text-center">Staff profiles</span>
          </v-col>
          <v-col cols="6">
              <h3 class="text-center primary--text display-3" v-if="hasScouting">
                {{scoutingCount}}
              </h3>
              <btn-add-scouting class="d-flex justify-center my-3" v-else></btn-add-scouting>
              <span class="d-block text-center">Scouting profiles</span>
          </v-col>
        </v-row>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
  import {mapEngagementColor} from "../../helpers/helpers";
  import BtnAddStaff from "../Buttons/Profiles/BtnAddStaff";
  import BtnAddScouting from "../Buttons/Profiles/BtnAddScouting";

  const LABELS = [
    {label: 'Good', value: 2},
    {label: 'Medium', value: 1},
    {label: 'Low', value: 0},
  ];

  export default {
    name: "UserStateOfTheArt",
    components: {BtnAddScouting, BtnAddStaff},
    props: {
      teamAverage: {
        type: Array
      },
      user: {
        type: Object,
        default: (() => {
        })
      }
    },
    computed: {
      currentActivityLabel() {
          //console.log('this.teamAverage', this.teamAverage)
        if (this.teamAverage && this.teamAverage.length > 0) {
          const roundedValue = Math.round((this.teamAverage[0].averageEngagement) * 100) / 100
          return LABELS.find(e => e.value === 2 - Math.round(roundedValue))
        }
        return null
      },
      currentActivityClass() {
        return this.currentActivityLabel && mapEngagementColor(2 - this.currentActivityLabel.value) + '--text';
      },
      staffCount() {
        return this.user && this.user.edges && this.user.edges.staff.count
      },
      scoutingCount() {
        return this.user && this.user.edges && this.user.edges.scouting.count
      },
      hasStaff(){
        return this.staffCount > 0
      },
      hasScouting(){
        return this.scoutingCount > 0
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Widgets/UserStateOfTheArt.vue